<template>
    <div class="chart-wrapper pb-4">
        <lottery-info-container clickable customClass="px-4 pt-4">
            <template #top>
                <vue-apex-charts
                    class="dashboard-graph flex-grow-1 dashboard-circle"
                    height="341px"
                    :series="series"
                    :options="options"
                ></vue-apex-charts>
            </template>
        </lottery-info-container>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import LotteryInfoContainer from '@/components/lottery/LotteryInfoContainer.vue'

export default {
    props: {
        chartOptions: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            options: {
                chart: {
                    type: 'donut',
                    toolbar: {
                        show: false
                    },
                    height: 200
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '80%'
                        }
                    }
                },
                title: {
                    text: this.chartOptions.title,
                    align: 'left',
                    margin: 30,
                    offsetX: 8,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        fontFamily: 'Red Hat Display',
                        color: 'var(--primary)'
                    }
                },
                legend: {
                    position: 'left',
                    horizontalAlign: 'left',
                    fontSize: '14px',
                    fontFamily: 'Red Hat Display, sans-serif',
                    offsetY: 20,
                    itemMargin: {
                        horizontal: 8,
                        vertical: 6
                    }
                },
                responsive: [
                    {
                        breakpoint: 1250,
                        options: {
                            legend: {
                                position: 'bottom',
                                offsetY: 0
                            }
                        }
                    },
                    {
                        breakpoint: 425,
                        options: {
                            title: {
                                offsetY: 5,
                                style: {
                                    fontSize: '11px'
                                }
                            },
                            legend: {
                                fontSize: '12px'
                            }
                        }
                    }
                ],
                dataLabels: {
                    enabled: false
                },
                labels: this.chartOptions.labels,
                colors: [
                    'var(--primary)',
                    '#006DD1',
                    '#57C5FA',
                    '#EB5757',
                    '#FF60AC',
                    '#FFC419',
                    '#0FCC89',
                    '#E6E6E5'
                ]
            },
            series: this.chartOptions.series
        }
    },
    components: {
        VueApexCharts,
        LotteryInfoContainer
    }
}
</script>

<style lang="scss">
.chart-wrapper {
    background-color: #fff;
    border: 1px solid var(--color-gray-300);
    border-radius: 0.3125rem;
    .dashboard-graph {
        border: none;
        @media (max-width: 768px) {
            padding-top: 0;
        }
    }
    .dashboard-circle {
        height: 200px;
    }
}
</style>
